module.exports = __webpack_public_path__ + "static/media/arrow-gradient.c71d4b60.png";